import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function DownloadIcon(props: SvgIconProps) {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99998 0.666626C7.36817 0.666626 7.66665 0.965103 7.66665 1.33329L7.66665 8.39048L9.86191 6.19522C10.1223 5.93487 10.5444 5.93487 10.8047 6.19522C11.0651 6.45557 11.0651 6.87768 10.8047 7.13803L7.47138 10.4714C7.21103 10.7317 6.78892 10.7317 6.52858 10.4714L3.19524 7.13803C2.93489 6.87768 2.93489 6.45557 3.19524 6.19522C3.45559 5.93487 3.8777 5.93487 4.13805 6.19522L6.33331 8.39048L6.33331 1.33329C6.33331 0.965103 6.63179 0.666626 6.99998 0.666626ZM0.99998 13.3333C0.63179 13.3333 0.333313 13.6318 0.333313 14C0.333313 14.3681 0.63179 14.6666 0.99998 14.6666L13 14.6666C13.3682 14.6666 13.6666 14.3681 13.6666 14C13.6666 13.6318 13.3682 13.3333 13 13.3333L0.99998 13.3333Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDownloadIcon = React.memo(DownloadIcon);
export default MemoDownloadIcon;
